import React from 'react';
import PropTypes from 'prop-types';
import Faq from '../Faq';

import './faqsection.scss';

const FaqSection = ({ data, title }) => (
  <div className="faq-section">
    <h2 className="faq-section__title">{title}</h2>
    {
      data.map(({ faq_item: f }) => <Faq key={f.question} question={f.question} answer={f.answer} />) // eslint-disable-line
    }
  </div>
);

FaqSection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    faq_item: PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }),
  })).isRequired,
  title: PropTypes.string.isRequired,
};

export default FaqSection;



// WEBPACK FOOTER //
// ./src/components/Faqs/FaqSection/index.jsx